import { createButton, type ClickProps } from './createButton';

interface ConfirmCancelButtonProps {
  onClick: () => void;
  label?: string;
}

export const ConfirmCancelButton = createButton<ConfirmCancelButtonProps>({
  className:
    'h-9 rounded-lg px-4 text-[13px] text-zinc-400 transition-colors hover:bg-white/[0.06] hover:text-zinc-200',
  content: (props) => props.label ?? 'Cancel',
});

export const ConfirmDeleteButton = createButton<ClickProps>({
  className:
    'h-9 rounded-lg bg-red-500/20 px-4 text-[13px] text-red-400 transition-colors hover:bg-red-500/30',
  content: 'Delete',
});
